// Hide quantity and assign on open draft shift modal for Line Scheduling
export const HARDCODED_SHOW_QUANTITY_AND_ASSIGN_ON_OPEN_DRAFT_SHIFT_MODAL = false;

// Hide SMS/Email notification settings on General Settings page until the API supports them
export const HARDCODED_SHOW_SMS_EMAIL_NOTIFICATIONS_ON_GENERAL_SETTINGS_PAGE = true;
